module.exports = __webpack_public_path__ + "img/interrogation-background.9533dc49.png";